import { render, staticRenderFns } from "./printPayFeeXiangyun.vue?vue&type=template&id=bf4cac66&scoped=true"
import script from "./printPayFeeXiangyun.vue?vue&type=script&lang=js"
export * from "./printPayFeeXiangyun.vue?vue&type=script&lang=js"
import style0 from "./printPayFeeXiangyun.vue?vue&type=style&index=0&id=bf4cac66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4cac66",
  null
  
)

export default component.exports